// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const noopFunction = (...args: any[]) => {
  return;
};
